<template>
  <div>
    <van-sticky>
      <van-nav-bar
        title="订单详情"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
        right-text="配送完成"
        @click-right="senddone"
      />
    </van-sticky>





    <van-cell-group inset style="margin-top: 40px;">
      <van-cell title="配送单编号" :value="orderdata.sendbh" />
      <van-cell title="订单状态">
          <template #right-icon>
            <van-tag type="default" v-if="orderdata.status==0">未发布</van-tag>
            <van-tag type="warning" v-if="orderdata.status==1">等待配送</van-tag>
            <van-tag type="info" v-if="orderdata.status==2">配送完成</van-tag>
          </template>
      </van-cell>
      <van-cell title="创建时间" :value="orderdata.create_datetime" />
      <van-cell title="更新时间" :value="orderdata.update_datetime" />

    </van-cell-group>

    <van-cell-group inset style="margin-top: 40px;">
      <div style="width: 96% height:30px;margin-top:5px;">
        <span style="margin-left: 5px;font-size: 14px;"><b>配送图片</b></span>
      </div>
      <div style="width: 99%;margin: 0 auto;margin-top: 10px;">
        <van-uploader :after-read="upload" v-model="fileList" @delete="todelete" style="width: 4rm;height: 4rm;" />
      </div>

        <van-button type="primary" style="width: 100%;" @click="toupload">上传</van-button>

      </van-cell-group>

    <van-cell-group inset style="margin-top: 40px;">
      <van-cell title="客户名称" :value="orderdata.clientname" />
      <van-cell title="支付类型" :value="orderdata.pay_type" />
      <van-cell title="联系人" :value="orderdata.lxr" />
      <van-cell title="联系电话" :value="orderdata.phone" />
      <van-cell title="地址" :value="orderdata.address" />
    </van-cell-group>

    <van-cell-group inset style="margin-top: 40px;">
      <van-cell title="送货方式" :value="orderdata.send_type" />
      <van-cell title="订单总价" :value="orderdata.total_price" />
      <van-cell title="备注信息" :value="orderdata.beizhu" />
    </van-cell-group>
    <van-row type="flex" justify="space-between">
      <van-col :span="6" :offset="1">
        <van-button type="danger" v-if="orderdata.status==0" @click="delorder">删除订单</van-button>
      </van-col>
      <van-col :span="6">
        <van-button type="primary"  v-if="orderdata.status==0"  @click="isshenpi">发布订单</van-button>
      </van-col>
      </van-row>

    <van-divider>订单产品</van-divider>

    <van-cell-group inset style="margin-top: 40px;" v-for="pd in products" :key="pd.uuid">
      <van-cell title="产品名称" :value="pd.productname" />
      <van-cell title="数量" :value="pd.count+pd.danwei" />
      <van-cell title="数量备注" :value="pd.beizhu" />
      <van-cell title="仓库" :value="pd.cangkuname" />
      <van-cell title="小计" :value="pd.total_price" />
    </van-cell-group>





  </div>
</template>

<script>
  import * as Api from './api.js'
import { Toast } from 'vant';
import OSS from 'ali-oss'
import { uuid } from 'vue-uuid';
  export default {
    name: 'getmyorder',
    data () {
      return {
        value:'',
        orderdata:{},
        orderid:'',
        shenpireson:'',
        spresonshow:false,
        products:[],
        fileList:[],
        client:'',
        accessKeyId:'',
        accessKeySecret:'',
        securityToken:'',
        region:'oss-cn-beijing.aliyuncs.com',
        bucket:'mpsy',
        endpoint:'oss-cn-beijing.aliyuncs.com',
        flist:[]
      }
    },
    created() {
      this.$store.dispatch('getlocaluserinfo').then(res=>{
        this.orderid = this.$route.query.id
        this.getorderdetail()
        this.getpeisongproducts()
        this.getauth()
      })

    },
    methods:{
      getorderdetail(){
        Api.sendorderdetail(this.orderid).then(res=>{
          console.log(res.data)
          this.orderdata = res.data
          console.log( res.data.peisongpics)
          if(res.data.peisongpics!=''){
            res.data.peisongpics.split(',').forEach(item=>{
              let info = {
                url:item,
              }
              this.fileList.push(info)
              this.flist.push(item)
            })
          }

          console.log(this.fileList)
        })
      },
      getpeisongproducts(){
        let query={
          sendorder:this.orderid
        }
        Api.peisongproducts(query).then(res=>{
          this.products = res.data.data
          this.orderdata.total_price = 0
          this.products.forEach(item=>{
            this.orderdata.total_price += Number(item.total_price)
          })
        })

      },
      onClickLeft(){
        this.$router.push({path:'/cangkuviews/sendorder'})
      },
      senddone(){
        let data = {
          id:this.orderid,
          status:2
        }
        Api.peisongdone(data).then(res=>{
          console.log(res.data)
          this.getorderdetail()
        })
      },
      getauth(){
        Api.getAuthorization().then(res=>{
        	var that = this
        	this.accessKeyId = res.accessKeyId
        	this.accessKeySecret = res.accessKeySecret
        	this.securityToken = res.securityToken

        	this.client = new OSS({
        		region: that.region,
        		accessKeyId: that.accessKeyId,
        		accessKeySecret:that.accessKeySecret,
        		stsToken: that.securityToken,
        		bucket: that.bucket,
        		secure:true,
        		endpoint:that.endpoint,
        	})

        })
      },
      upload(file){
      	// console.log(file)
      	let type = file.file.type.split('/')
      	let name ='peisongdan/'+ uuid.v4() +'.'+ type[1]
      	let reader = new FileReader();//将图片2将转成 base64 格式
      	var that = this
      	reader.readAsArrayBuffer(file.file);//读取成功后的回调
      	file.rname = name
      	reader.onload=function(){
      		that.client.put(name, new Buffer(this.result)).then(res=>{
      			let url = 'http://file.mpjt.net/'+name
      			that.flist.push(url)
      		})
      	};

      },

      toupload(){

      	var that = this
        let imgurl = this.flist.join(',')

        let canshu = {
        	peisongpics:imgurl,
          id:this.orderdata.id
        }

        Api.savepics(canshu).then(res=>{
          console.log(res)
        	if(res.msg=='更新成功'){
        		Toast({
        		  message: '上传成功！',
        		  icon: 'like-o',
        		});
        	}
        })



      	// console.log(this.flist)

      },
      todelete(file){
        console.log(file)
      	let index = this.flist.indexOf(file.url)
        this.flist.splice(index,1)
      }






    }
  }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/cangkuviews/sendorderdetail/index.vue